"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var SeasonsByProgramByOrg = require("../core/gql/queries/seasons-by-programs-by-orgs");
var ShowOrganization = require("../core/gql/queries/show-organizations");
var constants_1 = require("../core/constants");
var react_router_dom_1 = require("react-router-dom");
var HubNav = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var params = react_router_dom_1.useParams();
    var history = react_router_dom_1.useHistory();
    var orgId = params.orgId;
    var getOrg = react_apollo_1.useQuery(ShowOrganization.QUERY, {
        variables: { organizationId: +orgId },
        skip: !orgId,
    });
    var activeNamespace = (_a = history.location.pathname.split("/")) === null || _a === void 0 ? void 0 : _a[3];
    var rootPath = (_b = history.location.pathname.split("/")) === null || _b === void 0 ? void 0 : _b[1];
    var getTreeData = react_apollo_1.useQuery(SeasonsByProgramByOrg.QUERY);
    if (orgId == null && rootPath != "employee" && ((_d = (_c = getTreeData.data) === null || _c === void 0 ? void 0 : _c.organizations) === null || _d === void 0 ? void 0 : _d[0])) {
        history.push("/organizations/" + ((_f = (_e = getTreeData.data) === null || _e === void 0 ? void 0 : _e.organizations) === null || _f === void 0 ? void 0 : _f[0].id));
    }
    var orgTree = (_h = (_g = getTreeData.data) === null || _g === void 0 ? void 0 : _g.organizations) === null || _h === void 0 ? void 0 : _h.map(function (org) {
        var _a, _b;
        return {
            title: org.name,
            // useBadge: true,
            wrapItem: function (_a) {
                var children = _a.children;
                return React.createElement(react_router_dom_1.Link, { to: "/organizations/" + org.id }, children);
            },
            tree: ((_a = org.programs) === null || _a === void 0 ? void 0 : _a.length) == 0 ? null : (_b = org.programs) === null || _b === void 0 ? void 0 : _b.map(function (program) {
                var _a;
                return {
                    title: program.name,
                    useBadge: true,
                    wrapItem: function (_a) {
                        var children = _a.children;
                        return React.createElement(react_router_dom_1.Link, { to: "/organizations/" + org.id + "/programs/" + program.id }, children);
                    },
                    tree: ((_a = program === null || program === void 0 ? void 0 : program.seasons) === null || _a === void 0 ? void 0 : _a.length) == 0 ? null : program === null || program === void 0 ? void 0 : program.seasons.map(function (season) {
                        return {
                            title: season.name,
                            // useBadge: true,
                            wrapItem: function (_a) {
                                var children = _a.children;
                                return React.createElement("a", { href: constants_1.TEAMSNAP_URL + "/team/set_division/" + season.tsDivisionId }, children);
                            }
                        };
                    })
                };
            })
        };
    });
    return (React.createElement(teamsnap_ui_1.Nav, { headerItem: {
            image: 'https://aa5498032991a101442c-34c0f4eec246050dfc1ee92670a7b97d.ssl.cf1.rackcdn.com/logo-icon-dafd29abff7b6ca55ad71c35bd34d679.png',
            title: (_k = (_j = getOrg.data) === null || _j === void 0 ? void 0 : _j.showOrganization) === null || _k === void 0 ? void 0 : _k.name,
        }, mods: "u-size2of12", flyoutSections: [
            {
                heading: "Organizations",
                tree: orgTree
            },
        ] },
        React.createElement(teamsnap_ui_1.Nav.Item, { icon: "divisions", isActive: activeNamespace == "programs", wrapItem: function (_a) {
                var children = _a.children;
                return React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/programs" }, children);
            } }, "Programs"),
        React.createElement(teamsnap_ui_1.Nav.Item, { icon: "user", isActive: activeNamespace == "members", wrapItem: function (_a) {
                var children = _a.children;
                return React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/members" }, children);
            } }, "Members"),
        React.createElement(teamsnap_ui_1.Nav.Item, { icon: "roster", isActive: activeNamespace == "staff", wrapItem: function (_a) {
                var children = _a.children;
                return React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/staff" }, children);
            } }, "Staff"),
        React.createElement(teamsnap_ui_1.Nav.Item, { icon: "settings", isActive: activeNamespace == "settings", wrapItem: function (_a) {
                var children = _a.children;
                return React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/settings" }, children);
            } }, "Settings")));
};
exports.default = HubNav;
//# sourceMappingURL=hub-nav.js.map